import { ERROR } from '../../Core.constants';

export const L10N = {
  NOTIFICATION_ERROR: {
    [ERROR.NOT_AVAILABLE]: { id: 'common.notification.error_not_available' },
    [ERROR.PARAMETER_ERROR]: { id: 'common.notification.error_parameter' },
    [ERROR.UNKNOWN]: { id: 'common.notification.error_unknown' },
  },
  NOTIFICATION_BETTER_PRICE: { id: 'core.notification.better_price' },
  NOTIFICATION_PRICE_CHANGED: { id: 'core.notification.price_changed' },
  // -- <Details> ------------------------------------------------------------- */
  LABEL_BOOKING_DETAILS: { id: 'core.label.booking_details' },
  LABEL_BOOKING_EXTRAS: { id: 'core.label.booking_extras' },
  LABEL_OBSERVATIONS: { id: 'common.label.observations' },

  /* -- <Form> -------------------------------------------------------------- */
  ACTION_LOGIN: { id: 'common.action.login' },
  ACTION_MORE_INFO: { id: 'common.action.more_info' },
  ACTION_SIGNUP: { id: 'common.action.signup' },
  COMMENTS_HINT: { id: 'core.label.comments_hint' },
  LABEL_ADDRESS: { id: 'common.label.address' },
  LABEL_ADDITIONAL_INFO: { id: 'common.label.additional_information' },
  LABEL_CITY: { id: 'common.label.city' },
  LABEL_COMMENTS: { id: 'common.label.comments' },
  LABEL_COMPANY: { id: 'common.label.company' },
  LABEL_CONDITIONS: { id: 'core.label.conditions' },
  LABEL_COUNTRY: { id: 'common.label.country' },
  LABEL_DNI: { id: 'common.label.id_card' },
  LABEL_EMAIL: { id: 'common.label.email' },
  LABEL_FIRSTNAME: { id: 'common.label.firstname' },
  LABEL_IDPASSPORT: { id: 'common.label.id_passport' },
  LABEL_JOINCLUB_BENEFITS: { id: 'core.label.join_club_benefits' },
  LABEL_JOINCLUB_WITH_DISCOUNT: { id: 'core.label.join_club_with_discount' },
  LABEL_LASTNAME: { id: 'common.label.lastname' },
  LABEL_PERSONAL_DETAILS: { id: 'core.label.personal_details' },
  LABEL_PHONE_PREFIX: { id: 'common.label.phone_prefix' },
  LABEL_PHONE: { id: 'common.label.phone' },
  LABEL_PRIVACYPOLICY: { id: 'core.label.checkout_privacy_policy' },
  LABEL_REQUIRED: { id: 'common.label.required' },
  LABEL_ROOM_NUMBER: { id: 'common.label.room_number' },
  LABEL_SECONDLASTNAME: { id: 'common.label.second_lastname' },
  LABEL_STATEREGION: { id: 'common.label.state_region' },
  LABEL_SUBJECT_TO_AVAILABILITY: { id: 'core.label.subject_to_availability' },
  LABEL_TERMS_AND_CONDITIONS: { id: 'common.label.terms_and_conditions' },
  LABEL_ZIPCODE: { id: 'common.label.zip_code' },
  NOTIFICATION_AGENCY: { id: 'core.notification.agency' },
  NOTIFICATION_NO_CARD: { id: 'core.notification.no_card' },
  NOTIFICATION_SESSION_BOOKING: { id: 'core.notification.session_booking' },

  /* -- <Confirmation> ------------------------------------------------------ */
  ACTION_BOOK_NOW: { id: 'core.action.book_now' },
  NOTIFICATION_SSL_ENCRYPTION: { id: 'common.notification.ssl_encryption' },

  /* -- <Unconfirmed> ------------------------------------------------------- */
  LABEL_UNCONFIRMED: { id: 'core.label.reservation_unconfirmed' },
  LABEL_UNCONFIRMED_EMAIL_SENT: { id: 'core.label.reservation_unconfirmed_email_sent' },
  LABEL_UNCONFIRMED_INSTRUCTIONS: { id: 'core.label.reservation_unconfirmed_instructions' },
  LABEL_UNCONFIRMED_HOLD_TITLE: { id: 'core.label.reservation_unconfirmed_hold_title' },
  LABEL_UNCONFIRMED_HOLD: { id: 'core.label.reservation_unconfirmed_hold' },
  LABEL_UNCONFIRMED_PENDING_TITLE: { id: 'core.label.reservation_unconfirmed_pending_title' },
  LABEL_UNCONFIRMED_PENDING: { id: 'core.label.reservation_unconfirmed_pending' },
  NOTIFICATION_POS_CARD_DECLINED: { id: 'core.notification.pos_card_declined' },
  NOTIFICATION_POS_CONTACT_PROPERTY: { id: 'core.notification.pos_contact_property' },
  NOTIFICATION_POS_INSUFFICIENT_FUNDS: { id: 'core.notification.pos_insufficient_funds' },
  NOTIFICATION_POS_PROCESSING_ERROR: { id: 'core.notification.pos_processing_error' },
  NOTIFICATION_POS_USER_CANCELLED: { id: 'core.notification.pos_user_cancelled' },
  NOTIFICATION_UNKNOWN_POS_ERROR: { id: 'core.notification.unknown_pos_error' },
};
